<template>
  <tr
    class="cabinet__tbody-row"
    :class="{
      'notification-no-read': !isRead
    }"
  >
    <td style="width: 20%">
      {{ date }}
    </td>
    <td style="width: 75%">
      <p>
        <strong>{{ title }}</strong><br>
        {{ description }}
      </p>
    </td>
    <td>
      <router-link
        :to="{ name: 'NotificationDetail', params: { notificationID: id } }"
        class="tooltip__list-item-img tooltip__list-item-img--show show-contract"
      />
    </td>
  </tr>
</template>

<script>

import { dateFormat } from '@/utils/helpers';

export default {
  name: 'NotificationListTableItem',
  components: {},
  props: {
    item: {
      type: Object,
    },
  },
  computed: {
    id() {
      return this.item.id;
    },
    date() {
      return dateFormat(this.item.date);
    },
    title() {
      return this.item.title;
    },
    description() {
      return this.item.shortDescription;
    },
    isRead() {
      return this.item.isRead;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.show-contract {
  color: transparent;
  display: block;
  content: '';
  margin: 0 5px;
}

.notification-no-read,
.notification-no-read td {
  background-color: #EAF4DA !important;
}
</style>
